export default __webpack_public_path__ + "static/media/placeholder_dummy2016-beauty02-mobile-de.81c0c9b7.png";